module.exports = __webpack_public_path__ + "media/flags/dj-b9c13f96.svg";